import type { OwaDate } from '../../../schema';
import getIntlDateLunar from '../lunar/getIntlDateLunar';
import { LunarCalendarType } from '../lunar/LunarCalendarType';

const leapMonthCharacter = '윤';

const days = [
    '초하루',
    '(음)2',
    '(음)3',
    '(음)4',
    '(음)5',
    '(음)6',
    '(음)7',
    '(음)8',
    '(음)9',
    '(음)10',
    '(음)11',
    '(음)12',
    '(음)13',
    '(음)14',
    '보름',
    '(음)16',
    '(음)17',
    '(음)18',
    '(음)19',
    '(음)20',
    '(음)21',
    '(음)22',
    '(음)23',
    '(음)24',
    '(음)25',
    '(음)26',
    '(음)27',
    '(음)28',
    '(음)29',
    '그믐',
];

const months = [
    '정월',
    '이월',
    '삼월',
    '사월',
    '오월',
    '유월',
    '칠월',
    '팔월',
    '구월',
    '시월',
    '동짓달',
    '섣달',
];

export default function getIntlDateKoreanLunar(date: OwaDate): string {
    return getIntlDateLunar(date, LunarCalendarType.Korean, {
        days: days,
        months: months,
        leapMonthCharacter: leapMonthCharacter,
    });
}
